import type { SanityImage, SanityLogo } from '../@types';
import useBreakpoints from './useBreakpoints';
import { useSanity } from './useSanity';

type ResolvedLogo = {
  desktopImage?: SanityImage;
  mobileImage?: SanityImage;
  resolvedImage?: SanityImage;
};

export const resolveLogo = (logo: SanityLogo | undefined, isMobile: boolean): ResolvedLogo => {
  const desktopImage = logo?.image;
  const mobileImage = logo?.mobileImage;

  return {
    desktopImage,
    mobileImage,
    resolvedImage: isMobile ? (mobileImage ?? desktopImage) : desktopImage,
  };
};

const useResponsiveLogo = () => {
  const { isMobile } = useBreakpoints();
  const { data: logos } = useSanity<SanityLogo>('Logo');

  return {
    ...resolveLogo(logos?.[0], isMobile),
    isMobile,
  };
};

export default useResponsiveLogo;
